import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal as BSModal, Container, Row, Col } from 'react-bootstrap';
import './styles.css';

export default class Modal extends Component {
  static propTypes = {
    isShowing: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    headerIcon: PropTypes.node,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    footer: PropTypes.element,
    className: PropTypes.string,
    showCloseBtn: PropTypes.bool,
    iconClassName: PropTypes.string,
    centered: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'lg'])
  };

  handleClose = () => {
    this.props.onHide();
  };

  render() {
    const {
      isShowing,
      onHide,
      title,
      headerIcon,
      content,
      footer,
      className: propClassName,
      showCloseBtn = true,
      iconClassName,
      centered,
      size
    } = this.props;

    const imgProps = {
      src: headerIcon,
      alt: 'Icon',
      className: `header-icon ${iconClassName}`
    };

    return (
      <BSModal
        show={isShowing}
        onHide={onHide}
        className={propClassName}
        centered={centered}
        size={size}
      >
        <BSModal.Header>
          <Container>
            <Row>
              {showCloseBtn && (
                <button type="button" className="close" onClick={onHide}>
                  &times;
                </button>
              )}
              {(title || headerIcon) && (
                <Col xs={12} className="header-container">
                  {headerIcon && <img {...imgProps} alt="" loading="lazy" />}
                  <BSModal.Title>{title}</BSModal.Title>
                </Col>
              )}
            </Row>
          </Container>
        </BSModal.Header>
        <BSModal.Body>
          <Container>
            <Row>
              {typeof content === 'string' ? (
                <Col xs={12} dangerouslySetInnerHTML={{ __html: content }} />
              ) : (
                <Col xs={12}>{content}</Col>
              )}
            </Row>
          </Container>
        </BSModal.Body>
        {footer && (
          <BSModal.Footer>
            <Container>
              <Row>
                <Col xs={12}>{footer}</Col>
              </Row>
            </Container>
          </BSModal.Footer>
        )}
      </BSModal>
    );
  }
}
